import { GA1MenuService } from './ga1-menu.service';
import { Injector } from '@angular/core';

export function ga1MenuInitializer(injector:Injector) {
  return () => {
    const ga1MenuService:GA1MenuService = injector.get(GA1MenuService);
    // start procedure
    ga1MenuService.start();
  };
}